import React from "react";
import { useLocation } from "react-router-dom";
import { pageRegistry } from "../../App/pageRegistry";
import PageEditorComponent from "../editors/PageEditor/Component";
import {
  DashboardPagesPiece,
  DashboardSidebarPiece,
  DashboardWelcomePiece,
  LoginPiece,
} from "./Pieces";
import { useDashboardSession } from "./Hooks";
import "./Styles.scss";
export default function DashboardComponent() {
  const {
    session,
    busy,
    message,
    email,
    password,
    setEmail,
    setPassword,
    signIn,
    signOut,
  } = useDashboardSession();
  const location = useLocation();
  const selectedItemId = location.pathname.startsWith("/dashboard/menu/")
    ? location.pathname.slice("/dashboard/menu/".length)
    : undefined;
  const page = selectedItemId
    ? pageRegistry.find((entry) => entry.id === "menu")
    : pageRegistry.find((entry) => entry.editorPath === location.pathname);
  return (
    <main className={`cms ${session ? "cms-authenticated" : "cms-signed-out"}`}>
      <DashboardSidebarPiece
        active={page?.id}
        onSignOut={session && !page ? signOut : undefined}
      />
      <div className="cms-shell">
        <div className="cms-topline">
          <span>SouledOut Soul Food Cuisine</span>
          <div className="cms-topline-account">
            <span className="cms-owner-badge">
              <span /> Owner workspace
            </span>
            {session && !page && (
              <button className="cms-mobile-signout" onClick={signOut}>
                Sign out
              </button>
            )}
          </div>
        </div>
        {session?.name.startsWith("LOCAL DEMO") && (
          <p className="cms-demo-note">
            Local preview — changes are disposable and do not affect the live
            website.
          </p>
        )}
        {message && (
          <p className="cms-error" role="alert">
            {message}
          </p>
        )}
        {!session ? (
          busy ? (
            <p role="status">Checking your session…</p>
          ) : (
            <LoginPiece
              email={email}
              password={password}
              onEmail={setEmail}
              onPassword={setPassword}
              busy={busy}
              onSubmit={signIn}
            />
          )
        ) : (
          <>
            {page ? (
              <PageEditorComponent
                key={page.id}
                pageId={page.id}
                session={session}
                selectedItemId={selectedItemId}
              />
            ) : location.pathname === "/dashboard" ? (
              <>
                <DashboardWelcomePiece />
                <DashboardPagesPiece />
              </>
            ) : (
              <p>
                Editor not found. <a href="/dashboard">Return to dashboard</a>
              </p>
            )}
          </>
        )}
      </div>
    </main>
  );
}
